import { registerTldrawLibraryVersion } from "@tldraw/utils";
import { IncrementalSetConstructor } from "./lib/IncrementalSetConstructor.mjs";
import { RecordType, assertIdType, createRecordType } from "./lib/RecordType.mjs";
import {
  createEmptyRecordsDiff,
  isRecordsDiffEmpty,
  reverseRecordsDiff,
  squashRecordDiffs,
  squashRecordDiffsMutable
} from "./lib/RecordsDiff.mjs";
import {
  Store,
  createComputedCache
} from "./lib/Store.mjs";
import { StoreQueries } from "./lib/StoreQueries.mjs";
import { StoreSchema } from "./lib/StoreSchema.mjs";
import {
  StoreSideEffects
} from "./lib/StoreSideEffects.mjs";
import { devFreeze } from "./lib/devFreeze.mjs";
import {
  MigrationFailureReason,
  createMigrationIds,
  createMigrationSequence,
  createRecordMigrationSequence,
  defineMigrations,
  parseMigrationId
} from "./lib/migrate.mjs";
registerTldrawLibraryVersion(
  "@tldraw/store",
  "3.5.1",
  "esm"
);
export {
  IncrementalSetConstructor,
  MigrationFailureReason,
  RecordType,
  Store,
  StoreQueries,
  StoreSchema,
  StoreSideEffects,
  assertIdType,
  createComputedCache,
  createEmptyRecordsDiff,
  createMigrationIds,
  createMigrationSequence,
  createRecordMigrationSequence,
  createRecordType,
  defineMigrations,
  devFreeze,
  isRecordsDiffEmpty,
  parseMigrationId,
  reverseRecordsDiff,
  squashRecordDiffs,
  squashRecordDiffsMutable
};
//# sourceMappingURL=index.mjs.map
